/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: ChatAutomatonRequestMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_REQUEST);
	this.REPLACE_STRING = "_REPLACE_";
};
$hxClasses['com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler'] = com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.__name__ = ["com","inq","flash","client","control","messagehandlers","ChatAutomatonRequestMessageHandler"];
/** @private @type {Function} */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.__super__ = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
for(var k in com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype ) com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.prototype[k] = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype[k];

/**
 * onChange
 *
 * $type TFun([{ name => name, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * public static function onChange(name:String):Bool
 * @public
 * @static
 * @param {string} name
 * @return {boolean}
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.onChange = function(name) {
	/** @type {NodeList} */
	var elements = window.document.getElementsByName(name);
	if(elements.length > 0) {
		/** @type {Node} */
		var el = elements[elements.length - 1];/* Get last element by this name */
		switch(el.type) {
			case "checkbox":
				try {
					com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendInputState(name,"CHECKED",el.checked?"CHECKED":"null",true);
				} catch( e ) {
				}
				break;
		}
	}
	/*  TODO: add change handler for INPUT TEXT as well as other objects */
	return false;
};


/**
 * processMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * @public
 * @this com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.prototype.processMessage = function(message) {
	com.inq.flash.client.control.FlashPeer.debugLogDebugToTagServer(
		"VA_DATA_PASS",
		"processMessage triggered."
	);
	/** @type {string} */
	var agentName = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_MSG_AGENT_ALIAS);

	/** @type {boolean} */
	var isReplay = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY) === "1";
	if (!isReplay) {
		com.inq.flash.client.control.Incrementality.onAgentMsg();
	}

	/** @type {string} */
	var vaDataPass = message.getProperty(com.inq.flash.client.data.MessageFields.TYPE_VA_DATA_PASS);
	if (vaDataPass) {
		com.inq.flash.client.control.Incrementality.onVADataPass(vaDataPass);
	}

	/** @type {string} */
	var chatText = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_DATA);

	// If forceToConnect is true, means that Nina is failed and we want to show message with connect to Salesforce link
	var forceToConnect = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_TRANSFER_TO_TC_LIVE_AGENT_DISABLED) === "true";


	// Enable SalesForce Live Agent Chat.
	chatText = com.inq.addons.Salesforce.scanMessage(chatText, forceToConnect);
	chatText = this.handleCustomEventAttributes(chatText);
	
	/** @type {string} */
	var outText = this.createOutText(message, chatText);

	/** @type {string} */
	var replay = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY);
	var cssClass;
	if (message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ID) === com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.VIRTUAL_AGENT_NINA_ID) {
		cssClass = com.inq.flash.client.chatskins.ChatTextArea.VIRTUAL_AGENT_CLASS_NAME;
	}
	/** @type {Date} */
	var messageTimestamp = message.getPropertyAsDate(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_TIMESTAMP);
	this.getController().appendReceivedText(outText, agentName != null ? agentName : "", -1, true, null, replay, cssClass, messageTimestamp);

	// Add events handlers. Now all event handlers are in events array with format of [eventname, uniqueid, eventhandlerfunction].
	this.setEvents()

	if (true === com.inq.flash.client.chatskins.SkinControl.agentImageTypeEnabled) {
		com.inq.flash.client.chatskins.SkinControl.setAgentImage(com.inq.flash.client.chatskins.SkinControl.VIRTUAL_AGENT);
	}
};
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.prototype.setEvents = function() {

	setTimeout(function() {
		for (var i = 0; i < this.events.length; i++) {
			var event = this.events[i];
			var element = com.inq.ui.Container._getElementById(event[1], window.parent.document);
			if (element == null) {
				element = com.inq.ui.Container._getElementById(event[1]);
			}
			if (element) {
				element[event[0]] = event[2];
			}
		}
	}.bind(this), 200);
};
/**
 * Generating the outText that will be shown to the customer.
 *
 * Keep in mind that chatText may already been modified from what it is in the message data
 *
 * @public
 * @this com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message
 * @param {string}  chatText
 * @return {string}
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.prototype.createOutText = function(message, chatText) {

	/** @type {string} */
	var divId = "automation_" + new Date().getTime();
	//event handlers, each event in format of [eventname, uniqueid, eventhandlerfunction]
	if (!this.events) this.events = [];
	var msgDataObj = {};
	var msgData = this._createSentDTEventParametersString(message, divId, msgDataObj);
	var chatText = this._prepareChatText(chatText, msgData, msgDataObj, this.events);
	var outText = this._createOutText(chatText, divId, this.events);

	return outText;
};

/**
 * Generating the SentDTEvent parameters as a string
 *
 * our function sendDTEvent has 3 parameters
 * 1st - customer's answer
 * 2nd - this component, which called function
 * 3nd - fields which should be in answered msg (chat.automaton_request)
 * create 2-3nd parameters (js string)
 * like this, {type: "termination_automaton", id: "1234123",  state: "state", model: {"p1":"v1"}}
 * if there is no some parameter in msg, then it will not corresponding parameter in out msg chat.automaton_request
 *
 * @private
 * @this com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message
 * @param {string}  divId
 * @param {object}  msgDataObj reference to the msgData object and will be filled up by this function.
 * @return {string}
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.prototype._createSentDTEventParametersString = function(message, divId, msgDataObj) {
	if (!msgDataObj) msgDataObj = {};
	/** @type {string} */
	var msgData = "this, { divId: \"" + divId + "\"";
	msgDataObj.divId = divId;
	/*  add automaton type to out data */
	/** @type {?string} */
	var autType = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_TYPE);
	if(autType != null) {
		if(msgData.length > 0) msgData += ", ";
		msgData += "type : \"" + autType + "\"";
		msgDataObj.type = autType;
		if(autType == com.inq.flash.client.data.MessageFields.DATA_CHATROOM_MEMBER_VIRTUAL_AGENT) {
			com.inq.flash.client.chatskins.SndMgr.PlaySound();
			/** @type {string} */
			var clientName = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_USERNAME);
			if (clientName != null) {
				com.inq.flash.client.control.FlashVars.setCustomerName(clientName, true);
			}
		}
	}
	/*  add automaton id  to out data */
	/** @type {?string} */
	var automatonId = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_ID);
	if(automatonId != null) {
		if(msgData.length > 0) msgData += ", ";
		msgData += "id : \"" + automatonId + "\"";
		msgDataObj.id = automatonId;

		/** @type {Object} */
		var auxParams = com.inq.flash.client.control.FlashPeer.getSurveyAuxParams();
		if(auxParams == null) auxParams = { };
		auxParams["Auto"] = true;
		/** @type {?string} */
		var automatonList = auxParams["automatonList"];
		/** @type {Array} */
		var automatonArray;
		if(automatonList == null) automatonArray = new Array(); else automatonArray = automatonList.split(",");

		/** @type {boolean} */
		var isIdPresent = false;
		var /** @type {number} */ _g = 0;
		while(_g < automatonArray.length) {
			var /** @type {string} */ id = automatonArray[_g];
			++_g;
			if(id == automatonId) {
				isIdPresent = true;
				break;
			}
		}
		if(!isIdPresent) automatonArray[automatonArray.length] = automatonId;

		auxParams["automatonList"] = automatonArray.join(",");
		com.inq.flash.client.control.FlashPeer.setSurveyAuxParams(auxParams);
	}

	/*  add logged question */
	if(message.getProperty(com.inq.flash.client.data.MessageFields.KEY_DT_QUESTION) != null) {
		if(msgData.length > 0) msgData += ", ";
		var loggedQuestion = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_DT_QUESTION);
		msgData += "loggedQuestion : " + "\""+ loggedQuestion  + "\"";
		msgDataObj.loggedQuestion = loggedQuestion;
	}

	/*  add automaton state to out data */
	if(message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_STATE) != null) {
		if(msgData.length > 0) msgData += ", ";
		var state = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_STATE);
		msgData += "state : " + "\""+state+"\"";
		msgDataObj.state = state;
	}

	/*  add data model to out data */
	/*  NOTES: data model should be JSON object */
	if(message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_DATA_MODEL) != null) {
		if(msgData.length > 0) msgData += ", ";
		var model = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_DATA_MODEL);
		msgData += "model : " + model;
		msgDataObj.model = JSON.parse(model);
	}
	msgData += "}";

	return msgData;
};

/**
 * Prepare chatText by transforming and replacing Necessary placeholders.
 *
 * @this com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler
 * @param {string}  chatText
 * @param {string}  msgData
 * @param {object}  msgDataObj the msgData object.
 * @param {Array}  events event handlers returned by the function.
 * @return {string}
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.prototype._prepareChatText = function(chatText, msgData, msgDataObj, events) {
	if (!msgDataObj) msgDataObj = {};
	if (!events) events =  this.events = [];
	/*  HAVE TO BE string _REPLACE_ in "dt.data" , this text will be replaced on 2-3nd parameters */
	/*  e.g. <a onclick='return window.Inq.DT.sendDTEvent("exit",_REPLACE_);'>EXIT</a> */
	/*  out  <a onclick='return window.Inq.DT.sendDTEvent("exit",this, {data});'>EXIT</a> */
	// chatText = chatText.split(this.REPLACE_STRING).join(com.inq.utils.StringUtil.htmlAttrEscape(msgData));
	var onclickRegex = /onclick(.*?)sendDTEvent\("(.*)",?(.*)\).*?["']/;

	// define onclick function


	var counter = 1,matchedVal;
	// remove inline function and add event handler later. Find all occurences repeately.
	while (matchedVal = chatText.match(onclickRegex)) {
		// matched the first, then replace it
		var dtId = this.DT_EVENT_ID_PREFIX + new Date().getTime() + counter;
		counter += 1;

		var dtIdText = 'id="' + dtId + '"';
		function f(eventname) {
			return function (e) {
				e = e || window.event;
				var targ = e.target || e.srcElement;
				return com.inq.flash.client.control.FlashPeer.prepareDataAndSendDTEvent(eventname, targ, msgDataObj);
			};
		}

		chatText = chatText.replace(onclickRegex, dtIdText);

		events.push(['onclick', dtId, f(matchedVal[2])]); // put to events array and we will process later
	}

	// for all system replace the inline onclick with event handler (CSP compliance)
	onclickRegex = /onclick(.*?)sendVALinkClicked\(event\).*?["']/;
	if (onclickRegex.test(chatText)) {
		var vaLinkOnclick = function (event) {
			return Application.sendVALinkClicked(event);
		};
		var vaLinkId = this.VA_LINK_ID_PREFIX + new Date().getTime();
		var vaLinkIdText = 'id="' + vaLinkId + '"';
		chatText = chatText.replace(onclickRegex, vaLinkIdText);
		var eventName = "onclick";
		if (com.inq.utils.Capabilities.isIphone()) {
			// Need to prevent href for iPhone touch move. Let's put an undefined anchor... avoid using javascript:void(0) - CSP violation
			chatText = chatText.replace(/href="#"/g, "href=\"#notdefinedanchor\"");
		}
		events.push([eventName, vaLinkId, vaLinkOnclick]);
	}

	// region SalesForce inline automatons.
	/**
	 * @type {RegExp} startChatRegExp - regExp for
	 * {@link com.inq.addons.Salesforce.startChat} function call.
	 */
	var startChatRegExp = /((onclick|ontouchend)(.*?)startChat)(\(.*?\))"\s/g;
	/**
	 * @type {RegExp} startChatParamRegExp - regExp for get param with will be used
	 * when {@link com.inq.addons.Salesforce.startChat} function called.
	 */
	var startChatParamRegExp = /(startChat\(')(.*?)('\)")/;
	/**
	 * @type {RegExp} prepareRegExp - regExp for
	 * {@link com.inq.addons.Salesforce.prepare} function call.
	 */
	var prepareRegExp = /((onclick|ontouchend)(.*?)prepare)(\(.*?\))"\s/g;
	/**
	 * @type {RegExp} prepareParamRegExp - regExp for get param with will be used when
	 * {@link com.inq.addons.Salesforce.prepare} called.
	 */
	var prepareParamRegExp = /(prepare\(')(.*?)('\)")/;
	/**
	 * @type {RegExp} endChatRegExp - regExp for
	 * {@link com.inq.addons.Salesforce.endChat} function call.
	 */
	var endChatRegExp = /((onclick|ontouchend)(.*?)endChat)(\(.*?\))"\s/g;
	/**
	 * @type {Function} salesForceHandler - variable which stored SalesForce function
	 * to call them later.
	 */
	var salesForceHandler;
	/**
	 * @type {String} param - variable for store string param which we pass in called
	 * SalesForce function.
	 */
	var param;

	if (startChatRegExp.test(chatText)) {
		if (startChatParamRegExp.test(chatText)) {
			param = chatText.match(startChatParamRegExp)[2];
		}
		salesForceHandler = function () {
			return com.inq.addons.Salesforce.startChat(param);
		};
		chatText = this._cleanMessageAddEvent(
			events,
			startChatRegExp,
			chatText,
			salesForceHandler
		);
	} else if (prepareRegExp.test(chatText)) {
		if (prepareParamRegExp.test(chatText)) {
			param = chatText.match(prepareParamRegExp)[2];
		}
		salesForceHandler = function () {
			return com.inq.addons.Salesforce.prepare(param);
		};
		chatText = this._cleanMessageAddEvent(
			events,
			prepareRegExp,
			chatText,
			salesForceHandler
		);
	} else if (endChatRegExp.test(chatText)) {
		salesForceHandler = function () {
			return com.inq.addons.Salesforce.endChat();
		};
		chatText = this._cleanMessageAddEvent(
			events,
			endChatRegExp,
			chatText,
			salesForceHandler
		);
	}
	// endregion

	return chatText;
};

/**
 *
 * This function will remove js functions call from message if they mach passed
 * regExp, and create custom event with saved context for removed functions.
 *
 * @param {Array<Array>}  events             array with stored custom events.
 * @param {RegExp}        regExp             regExp which we use for remove
 *                                           functions call from message.
 * @param {string}        chatText           Incoming message.
 * @param {Function}      salesForceHandler  selected salesForce function which
 *                                           will be added to created event.
 *
 * @return {string}       chatText           message without Sales Force
 *                                           functions calls.
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.prototype._cleanMessageAddEvent = function(events, regExp, chatText, salesForceHandler) {
	/** @type {String} eventType - type of new event. */
	var eventType = com.inq.utils.Capabilities.isIphone() ? "ontouchend" : "onclick";
	/** @type {RegExp} idRegExp - regExp which we use for remember all IDs of passed message. */
	var idRegExp = /id=".*?"/g;
	/** @type {RegExp} idRegExp - regExp which we use for extract id value */
	var idValueRegExp = /(id=")(.*?)(")/;

	chatText = chatText.replace(regExp, "");
	var matchedIdArray = chatText.match(idRegExp);
	var id;
	for (var i = 0; i < matchedIdArray.length; i++) {
		var currentID = matchedIdArray[i];
		if ((currentID.indexOf(this.VA_LINK_ID_PREFIX) === -1)
			&& (currentID.indexOf(this.DT_EVENT_ID_PREFIX) === -1)) {
			id = currentID.match(idValueRegExp)[2];
		}
	}
	events.push([eventType, id, salesForceHandler]);

	return chatText;
};

/**
 * Generating the actual outText
 *
 * @private
 * @this com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler
 * @param {string}  chatText
 * @param {string}  divId
 * @param {Array}  events event handlers returned by the function.
 * @return {string}
 */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.prototype._createOutText = function(chatText, divId, events) {
	if (!events) events = [];
	/** @type {string} */
	var outText = "<span id='" + divId + "' >" + chatText + "</span>";
	/** @type {HTMLElement} */
	var tmpDiv = document.createElement("DIV");

	/* Add onchange handler to all input fields */
	tmpDiv.innerHTML = outText;
	/** @type {HTMLCollection} */
	var items = tmpDiv.getElementsByTagName("INPUT");
	for (var i = 0, l = items.length; i < l; i++) {
		/** @type {?string} */
		var name = items[i].name;
		if (name == null || name == "") {
			continue;
		}
		/** @type {string} */
		var uniqueId = "automaton_input_" + new Date().getTime() + i;
		/** @type {HTMLElement} */
		var el = items[i];
		if(el.type == "checkbox" || el.type == "text") {
			items[i].setAttribute("id", uniqueId);


			var f = function(name) {
				var _that = this;
				return function(event) {
					com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.onChange(name);
					_that.setEvents()
				}
			}.bind(this);



			events.push(["onchange", uniqueId, f(name)]);
		}
	}
	outText = tmpDiv.innerHTML;

	/*
	 * remove all paragraph tags and replace them with two line breaks.
	 * IE has a bug, where paragraph tags add an extra <BR> tag everytime it is inserted.
	 * This creates a problem where we get a lot of extra <BR>s on every refresh of the text area.
	 */
	/** @type {EReg} */
	var regexP = new EReg("<\\s*P\\b\\s*[^>]*>","ig");
	/** @type {EReg} */
	var regexPEnd = new EReg("<\\s*/P\\s*>","ig");
	outText = regexP.replace(outText,"<br/><br/>");
	outText = regexPEnd.replace(outText,"");

	return outText;
};


/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.prototype.REPLACE_STRING = null;
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.VIRTUAL_AGENT_NINA_ID = "virtualAssistant.nina";
/** @private @type {com.inq.flash.client.data.Chat} */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.prototype.chat = null;
/** @type {com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler} */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler;

/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.prototype.DT_EVENT_ID_PREFIX = "automaton_sendDTEvent_";
/** @private @type {string} */
com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler.prototype.VA_LINK_ID_PREFIX = "automaton_vaLink_";
